import type { Upload, UploadRequest } from './types';
import GatewayAxiosClient from '../GatewayAxiosClient';
import { getToken } from '../../session';

export class FileService {
  public async fetchUploads(): Promise<Upload[]> {
    const res = await GatewayAxiosClient.get(`/getFileList`, {
      headers: {
        authorization: getToken(),
      },
    });
    return res.data.fileList;
  }
  public async uploadFile(upload: UploadRequest): Promise<string> {
    const formData = new FormData();
    Object.entries(upload).map((val: any) => {
      formData.append(val[0], val[1]);
      return formData;
    });
    const res = await GatewayAxiosClient.post(`/uploadFile`, formData, {
      headers: {
        authorization: getToken(),
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  }
  public async retrieveFile(s3Location: string): Promise<ArrayBuffer> {
    const res = await GatewayAxiosClient.get(`/retrieveFile`, {
      params: {
        fileId: s3Location,
      },
      responseType: 'arraybuffer',
      headers: {
        authorization: getToken(),
      },
    });
    return res.data;
  }
  public async deleteFile(s3Location: string): Promise<string> {
    const res = await GatewayAxiosClient.delete(`/deleteFile`, {
      params: {
        fileId: s3Location,
      },
      headers: {
        authorization: getToken(),
      },
    });
    return res.data;
  }
}
